//------------------------------------------------------------------------
// Doughnut charts
//------------------------------------------------------------------------
// NOTE: Only import the necessary modules
// https://www.chartjs.org/docs/latest/getting-started/integration.html
import {Chart, ArcElement, DoughnutController, Tooltip} from 'chart.js';
Chart.register(ArcElement, DoughnutController, Tooltip);
// NOTE: Treeshaking doesn’t seem to be working when importing everything
// https://github.com/chartjs/Chart.js/issues/10163
// e.g. import Chart from 'chart.js/auto';

export default class DoughnutChart {
  constructor(el) {
    this.el = el;
    if (!this.el) {
      console.warn(`Unable to initialize doughnut chart, no matching element for “${this.el}”`);
      return false;
    }

    this.canvas = this.el.querySelector('canvas');
    if (!this.canvas) {
      console.warn('Unable to initialize doughnut chart, no <canvas> element found');
      return false;
    }

    // Track if chart has already initialized so IntersectionObserver doesn’t try to reinitialize
    this.hasInit = false;

    // Data labels
    this.labelEls = this.el.querySelectorAll('[data-label]');
    this.dataLabels = [...this.labelEls].map(el => el.getAttribute('data-label'));

    // Data values
    this.valueEls = this.el.querySelectorAll('[data-value]');
    this.dataValues = [...this.valueEls].map(el => el.getAttribute('data-value'));

    // Data colors
    this.dotEls = this.el.querySelectorAll('.Legend-dot');
    this.colors = [...this.dotEls].map(el => window.getComputedStyle(el).getPropertyValue('background-color'));

    this.isMethodology = !!this.el.closest('.Methodology');
    this.resizeEvent = new CustomEvent('resize-methodology');

    // Setup observer so we can init the chart once it’s in the viewport
    this.observer = new IntersectionObserver((entries) => {
      let entry = entries[0];
      if (entry.isIntersecting && !this.hasInit) {
        this.init();

        // Emit event to tell the Methodology expandable section to recalc its height
        if (this.isMethodology) {
          document.documentElement.dispatchEvent(this.resizeEvent);
        }
      }
    },
    {
      threshold: [0.5]
    });
    this.observer.observe(this.el);

    // Init charts in print view
    window.addEventListener('beforeprint', () => {
      this.init();
    });
  }

  init() {
    new Chart(this.canvas.getContext('2d'), {
      type: 'doughnut',
      data: {
        labels: this.dataLabels,
        datasets: [{
          label: this.canvas.getAttribute('data-title') || '',
          data: this.dataValues,
          backgroundColor: this.colors,
          borderWidth: 0,
        }]
      },
      options: {
        animation: {
          animateRotate: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        },
        responsive: true,
        plugins: {
          legend: false,
          tooltip: {
            displayColors: false,
            callbacks: {
              label: function(context) {
                return context.parsed + '% ';
              }
            }
          }
        }
      },
    });

    this.hasInit = true;
  }
}
